import { Component, Input } from '@angular/core';
import { SiteSettingModel } from "../../services/akita/site-setting-schema/site-setting.model";

@Component({
    selector: 'header-main',
    templateUrl: './header-main.component.html',
})
export class HeaderMainComponent {

    @Input()
    siteSetting: SiteSettingModel;

    whenLanguageChange($event): void {

    }
}
